import React from "react";
import { Link } from "react-router-dom";

const CardResetPasswordErrorToken = () => (
  <div className="password-reset-expired">
    <p className="password-reset-intro" role="status">
      Le lien de réinitialisation du mot de passe a expiré ou n’est pas valide.
      Merci de faire une nouvelle demande.
    </p>
    <p className="password-reset-help">
      Sur la page de connexion, sélectionnez « Je souhaite réinitialiser mon mot de passe »
      pour recevoir un nouveau lien par e-mail.
    </p>
    <Link to="/login" className="password-reset-button">Aller à la connexion</Link>
  </div>
);

export default CardResetPasswordErrorToken;
